<section class="reasignar-modal" [formGroup]="form">
  <header class="reasignar-modal__header">
    <div>
      <span class="reasignar-modal__eyebrow">{{ data?.contextLabel || 'Incidencias QA' }}</span>
      <h2>{{ data?.titulo || 'Reasignar responsable' }}</h2>
      <p>Selecciona {{ data?.roleLabel || 'un desarrollador' }} y registra el motivo del cambio.</p>
    </div>

    <button
      type="button"
      mat-icon-button
      class="reasignar-modal__close"
      (click)="close()"
      aria-label="Cerrar modal"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="reasignar-modal__body">
    <!-- T3b: mientras la resolución espera versión, reasignar no la pasa a revisión. -->
    <p class="reasignar-modal__aviso" *ngIf="data?.aviso">
      <span class="material-icons" aria-hidden="true">schedule</span>
      <span><strong>{{ data.avisoTitulo }}</strong> {{ data.aviso }}</span>
    </p>

    <mat-form-field appearance="outline" class="reasignar-modal__field">
      <mat-label>{{ data?.assignLabel || 'Reasignar a' }}</mat-label>
      <mat-select formControlName="selectedEmpleado">
        <mat-option *ngFor="let emp of data.listaEmpleados" [value]="emp.usuario.id">
          {{ emp.persona.nombreCompleto }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="reasignar-modal__field">
      <mat-label>Motivo</mat-label>
      <textarea matInput aria-label="Motivo" rows="5" maxlength="2000" formControlName="motivo"></textarea>
    </mat-form-field>
  </div>

  <footer class="reasignar-modal__footer">
    <button
      type="button"
      mat-raised-button
      class="btn app-form-btn app-form-btn--secondary"
      (click)="close()"
    >
      Cancelar
    </button>
    <button
      type="button"
      mat-raised-button
      class="btn app-form-btn app-form-btn--primary"
      [disabled]="form.invalid"
      (click)="save()"
    >
      Guardar asignación
    </button>
  </footer>
</section>
